<script setup lang="ts">
import { useCityStore } from '@/store/city/city'

type Props = {
  price: string | number
  tag?: 'span' | 'div' | 'p'
}

const props = withDefaults(defineProps<Props>(), {
  tag: 'span',
})

const { currencySymbol } = useCityStore()

const priceWithSymbol = computed(() => {
  return `${formatFloat(props.price)} ${currencySymbol}`
})
</script>

<template>
  <component :is="tag">{{ priceWithSymbol }}</component>
</template>
